/**
 * We only really need this when there's a dependency on the component name
 */
export enum PageNames {
    PlayPage='PlayPage',
}
